import { useMemo } from 'react'
import store from 'stores/store'
import { breakpoints } from 'utils/theme'

export const useViewport = () => {
  const width = store((s) => s.window.width)
  const height = store((s) => s.window.height)

  const [isMobile, isTablet, isDesktop] = useMemo(() => {
    if (!width) return [false, false, false]
    const mobile = width < breakpoints.sm
    const tablet = width >= breakpoints.sm && width < breakpoints.lg
    const desktop = width >= breakpoints.lg
    // const largeDesktop = width >= breakpoints.xl
    return [mobile, tablet, desktop]
  }, [width])

  return { width, height, isMobile, isTablet, isDesktop }
}
